import { css } from 'styled-components';
import {
  NextButton,
  PreviousButton,
} from '../../../../components/TestimonialWithImage/styles';
import { colors, themeSpecificColors } from '../../colors';

export default css`
  ${PreviousButton}, ${NextButton} {
    &:hover {
      box-shadow: 0 0 0 4px ${themeSpecificColors.core01_60};

      svg {
        fill: ${themeSpecificColors.core06};
      }
    }

    &:focus-visible {
      box-shadow: 0 0 0 4px ${themeSpecificColors.core01_60};

      svg {
        fill: ${themeSpecificColors.core06};
      }
    }

    &:active {
      box-shadow: 0 0 0 10px ${themeSpecificColors.core01_60};

      svg {
        fill: ${colors.neutral01};
      }
    }
  }
`;
